import React, { useReducer, useEffect } from "react";
import DialogContent from "@mui/material/DialogContent";
import dayjs from "dayjs";
import { get } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  TablePagination,
} from "@mui/material";
import { Typography } from "@mui/material";
import { I18n } from "aws-amplify/utils";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

const reducer = (lastState, action) => {
  switch (action.type) {
    case "DATA_RECEIVED":
      const accountAssets = action.value;
      if (Array.isArray(accountAssets)) {
        return { ...lastState, accountAssets: accountAssets, fetched: true };
      }
      return lastState;
    case "SET_SEARCH_TERM":
      return { ...lastState, searchTerm: action.value, page: 0 };
    case "SET_PAGE":
      return { ...lastState, page: action.value };
    case "SET_ROWS_PER_PAGE":
      return { ...lastState, rowsPerPage: action.value, page: 0 };
    default:
      return lastState;
  }
};

function TelemonitoringAssetStep(props) {
  const [state, dispatch] = useReducer(reducer, {
    accountAssets: [],
    fetched: false,
    searchTerm: "",
    page: 0,
    rowsPerPage: 25,
  });
  
  useEffect(() => {
    const tlmGetAccountAssets = async (accountID) => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/accountNumber/asset",
          options: {
          headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
              account_id: accountID,
              record_type_id: "0126N000000ChTeQAK",
          },
          },
        });

        const { body } = await restOperation.response;
        const response = await body.json();
        dispatch({ type: "DATA_RECEIVED", value: response });

        } catch (error) {
        console.error("Error fetching alarms:", error);
        throw error;
        }
      };
      tlmGetAccountAssets(props.mainFormData.account_id);
    }, []);

    const columns = [
    {
      field: "fsl_name_and_serial_number",
      headerName: I18n.get("Name"),
      align: "left",
      flex: 1,
    },
    {
      field: "local_monitoring_system_manufacturer",
      headerName: I18n.get("System Manufacturer"),
      align: "left",
      flex: 1,
    }, 
    {
      field: "local_monitoring_system_type",
      headerName: I18n.get("Type"),
      align: "left",
      flex: 1,
    }, 
  ];

    const handleRowClick = (row) => {
      props.setSelectedAccountAssets(row);
      props.handleMainFormData("tlm_asset_id", row.id);
    };

    const filteredAccountAssets = state.accountAssets.filter((row) => {
      const searchTerm = state.searchTerm.toLowerCase();
      return Object.values(row).some(
      (value) => value && value.toString().toLowerCase().includes(searchTerm)
      );
    });

    const { page, rowsPerPage } = state;

    const displayAccountAssets = filteredAccountAssets.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

  return (
    <DialogContent>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label={I18n.get("Search")}
            variant="outlined"
            fullWidth
            value={state.searchTerm}
            onChange={(e) =>
              dispatch({ type: "SET_SEARCH_TERM", value: e.target.value })
            }
            sx={{ marginBottom: 2 }}
          />
          <TableContainer>
            {!state.fetched ? (
              <Stack alignItems="center" sx={{ height: "100%" }}>
                <Skeleton
                  variant="rounded"
                  height={30}
                  width="100%"
                  sx={{ margin: "2px", marginTop: "5px" }}
                />
                <Skeleton
                  variant="rounded"
                  height={30}
                  width="100%"
                  sx={{ margin: "2px" }}
                />
                <Skeleton
                  variant="rounded"
                  height={30}
                  width="100%"
                  sx={{ margin: "2px" }}
                />
              </Stack>
            ) : (
              <>
                <Table>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell key={column.field}>
                          {column.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayAccountAssets.map((row) => (
                      <TableRow
                        key={row.fsl_name_and_serial_number}
                        onClick={() => handleRowClick(row)}
                        selected={row === props.selectedAccountAssets}
                      >
                        {columns.map((column) => (
                          <TableCell key={column.field}>
                            {row[column.field]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  count={filteredAccountAssets.length}
                  page={state.page}
                  onPageChange={(event, newPage) =>
                    dispatch({ type: "SET_PAGE", value: newPage })
                  }
                  rowsPerPage={state.rowsPerPage}
                  onRowsPerPageChange={(event) =>
                    dispatch({
                      type: "SET_ROWS_PER_PAGE",
                      value: parseInt(event.target.value, 10),
                    })
                  }
                  rowsPerPageOptions={[25]}
                />
              </>
            )}
          </TableContainer>
        </Grid>
      </Grid>
    </DialogContent>
  );
}

export default TelemonitoringAssetStep;
